<template>
  <section>
    <div class="row">
      <div class="col-12">
        <h4>Visualización</h4>
        <p>Seleccione las personas o áreas que van a visualizar el documento.</p>
      </div>
      <div class="wrapper-content px-3">
        <div class="row">
          <div class="col-6">
            <div class="row">
              <LmTreeSelect
                class="col-auto"
                multiple
                label="Usuarios"
                pathToGetOptions="/users/all"
                v-model="value.users"
              />
              <LmTreeSelect
                class="col-auto"
                multiple
                label="Áreas"
                pathToGetOptions="/codificatorbuilder/codificators/60ef327157c5ac23d879c0fb"
                v-model="value.areas"
              />
              <LmTreeSelect
                class="col-auto"
                multiple
                label="Subáreas"
                pathToGetOptions="/codificatorbuilder/codificators/60ef334457c5ac23d879c100"
                v-model="value.subareas"
              />
            </div>
          </div>

          <div class="col-6">
              <b-list-group v-if="viewers.length">
                <b-list-group-item v-for="(viewer, index) of viewers" :key="index">
                  <div class="d-flex align-items-center">
                    <font-awesome-icon
                      class="mr-2 fa-lg"
                      :icon="viewer.icon"
                    />
                    <span class="flex-grow-1">
                      {{ viewer.name }}
                    </span>
                    <font-awesome-icon
                      class="clickable fa-lg"
                      icon="times"
                      @click="onDeleteViewer(viewer)"
                    />
                  </div>
                </b-list-group-item>
              </b-list-group>
              <div v-else>
                <LmSvgIcon
                  icon="LmNoDataIcon"
                  width="7.5em"
                  wrapperClass="mb-4 d-flex justify-content-center"
                />
                <p class="text-center">
                  Todavía no se han seleccionado visualizadores para este documento.
                </p>
              </div>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'

export default {
  components: {
    LmTreeSelect
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    viewers () {
      let items = []
      for (const key in this.value) {
        const arr = this.value[key].map(el => {
          return {
            ...el,
            group: key,
            icon: this.setViewerIcon(key)
          }
        })
        items = items.concat(arr)
      }
      return items
    }
  },
  methods: {
    setViewerIcon (type) {
      const icons = {
        users: 'user',
        areas: 'building',
        subareas: 'users',
        mesas: 'user-friends'
      }
      return icons[type]
    },
    onDeleteViewer (viewer) {
      this.value[viewer.group] = this.value[viewer.group].filter(item => item.id !== viewer.id)
    }
  }
}
</script>
